import {getBodyWidgets, byMatching, getWidgetValue} from "sportinglife-react-common/widgets";
/*

WIDGET HELPERS

NB - very similar to (ie copied from from functions in) widgetHelpers.js in cms-web

*/
function getImageMediaIds(widgets) {
  return widgets.filter(byMatching({type: "Image"}, {
    key: "media",
    value: "true"
  })).map(widget => getWidgetValue(widget, "media_id"));
}

function getMediaIdsFromContent(content) {
  return (JSON.parse(content) || [])
    .map(tip => tip.image_id)
    .filter(imageId => !!imageId)
    .map(imageId => imageId.toString());
}

function getTipMediaIds(widgets) {
  return widgets
    .filter(byMatching({type: "Tip"}, {key: "media", value: "true"}))
    .map(widget => getWidgetValue(widget, "tips"))
    .filter(tips => !!tips)
    .reduce((acc, tip) => acc.concat(getMediaIdsFromContent(tip)), []);
}

export function getMediaWidgetIds(widgets) {
  const imageMediaIds = getImageMediaIds(widgets);
  const tipMediaIds = getTipMediaIds(widgets);

  return imageMediaIds.concat(tipMediaIds);
}

/*

end WIDGET HELPERS copied from cms-web

*/

export function getMetaDataWidget(widgets) {
  const [metaDataWidget] = widgets.filter(byMatching({type: "MetaData"}));

  return metaDataWidget;
}

export function getMetaDataWidgetValue(widgets, key) {
  const metaDataWidget = getMetaDataWidget(widgets);

  if (metaDataWidget) {
    return getWidgetValue(metaDataWidget, key);
  }
}

export function getArticleWordCount(article) {
  const articleBodyWidgets = getBodyWidgets(article.widgets);
  return articleBodyWidgets.reduce((previousValue, currentValue, index, array) => {
    const widget = array[index];
    if (widget.widget_type) {
      const html = getWidgetValue(widget, "html");
      if (!html) {
          return previousValue;
      }
      const text = html.replace(/<\/?[^>]+(>|$)/g, " ");

      return previousValue + text.split(' ').filter(word => word.length).length;
    }
  }, 0);
}

const WORDS_READ_PER_MINUTE = 250;

export function getArticleReadTime(article) {
    const wordCount = getArticleWordCount(article);
    return Math.ceil(wordCount / WORDS_READ_PER_MINUTE);
}




// WEBPACK FOOTER //
// ./modules/News/utils.js